import { render } from "./SelectDistributor.vue?vue&type=template&id=fc62cea4"
import script from "./SelectDistributor.vue?vue&type=script&lang=js"
export * from "./SelectDistributor.vue?vue&type=script&lang=js"
script.render = render

export default script